import { Stack, Box } from '@mui/material';
import { Button, colors, Typography } from '@sweep-io/sweep-design';
import { getActionPaywallBlockData } from './helper';
import { ActionPaywallSource } from '../paywallTypes';
import usePageblockEvents from '../../../../hooks/usePageblockEvents';

const PaywallVerticalLayout = ({
  paywallSource,
  variant = 'regular',
}: {
  paywallSource?: ActionPaywallSource;
  variant: 'regular' | 'wide';
}) => {
  const { bookDemoAndSendEvent } = usePageblockEvents();
  const data = getActionPaywallBlockData(paywallSource);
  const { header, subHeader, cta, imageVertical, imageVerticalWide } = data ?? {};

  return (
    <Stack width="100%" height="100%">
      <Stack justifyContent="space-between" height="100%" gap="96px">
        <Stack gap="40px">
          <Stack gap={1}>
            <Box maxWidth="70%">
              <Typography variant="h1-medium" color={colors.night[900]}>
                {header}
              </Typography>
            </Box>
            <Box maxWidth="80%">
              <Typography variant="body" color={colors.grey[800]}>
                {subHeader}
              </Typography>
            </Box>
          </Stack>
          <Box>
            <Button size="medium" onClick={() => bookDemoAndSendEvent(paywallSource)}>
              {cta}
            </Button>
          </Box>
        </Stack>
        <Box
          sx={{
            borderRadius: '16px',
            overflow: 'hidden',
            svg: {
              width: '100%',
            },
          }}
        >
          {variant === 'regular' ? imageVertical : imageVerticalWide}
        </Box>
      </Stack>
    </Stack>
  );
};

export default PaywallVerticalLayout;
